var getPromoterIdFromChannel = function getPromoterIdFromChannel(channel) {
  var _channel$data, _promoterChannel$valu, _promoterChannel$valu2;
  if ((channel == null ? void 0 : channel.name) !== 'parceiromagalu.com.br') return '';
  var promoterChannel = (_channel$data = channel.data) == null ? void 0 : _channel$data.find(function (item) {
    return item.name === 'store';
  });
  return (_promoterChannel$valu = promoterChannel == null ? void 0 : (_promoterChannel$valu2 = promoterChannel.value) == null ? void 0 : _promoterChannel$valu2.id) !== null && _promoterChannel$valu !== void 0 ? _promoterChannel$valu : '';
};
export default getPromoterIdFromChannel;